import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('pizzaCart') || '[]');
    } catch {
      return [];
    }
  });

  // sync to localStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem('pizzaCart', JSON.stringify(cart));
  }, [cart]);

  function addToCart(item) {
    setCart((prev) => {
      // check if same item already exists (match by name)
      const existing = prev.find((i) => i.name === item.name);
      if (existing) {
        return prev.map((i) =>
          i.name === item.name ? { ...i, quantity: i.quantity + (item.quantity || 1) } : i
        );
      }
      return [...prev, { ...item, quantity: item.quantity || 1 }];
    });
  }

  function removeFromCart(name) {
    setCart((prev) => prev.filter((i) => i.name !== name));
  }

  function updateQuantity(name, quantity) {
    if (quantity <= 0) {
      removeFromCart(name);
      return;
    }
    setCart((prev) => prev.map((i) => (i.name === name ? { ...i, quantity } : i)));
  }

  function clearCart() {
    setCart([]);
  }

  const cartTotal = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const cartCount = cart.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ cart, addToCart, removeFromCart, updateQuantity, clearCart, cartTotal, cartCount }}
    >
      {children}
    </CartContext.Provider>
  );
}
